export { errorPages } from '../en/error-pages';
